import React from 'react';

export default function createBodyColumn(column, key) {
    return(
        <td key={key} className={column.classNames}>{column.value}</td>
    );
}


// WEBPACK FOOTER //
// ./src/common/table/createBodyColumn.js